<template>
  <div id="ipo-credit">

    <header>
      <Hero/>
    </header>

    <main>

      <!-- OPENING  -->
      <OpeningBullets/>

      <!-- SOLUTION -->
      <Solution/>

      <!-- LAZY -->
      <component :is="lazy"></component>
      <!-- <Lazy /> -->

    </main>

  </div>
</template>

<script>
// import smoothScroll from 'smoothscroll'

import Solution from '../components/Solution'

// import Hero from '../components/HeroGirlAndCity'

import Hero from '../components/HeroFamilyAndKite'

// import Hero from '../components/HeroBridge'

import OpeningBullets from '../components/OpeningBullets'

// import Lazy from '../components/Lazy'

// window.document.body.onscroll = function () {
//   let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
//   let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
//   console.log(scrollTop, windowHeight, (scrollTop > windowHeight) + '')
// }

export default {
  name: 'IpoCredit',
  components: {
    Hero,
    OpeningBullets,
    Solution
  },
  data () {
    return {}
  },
  computed: {
    lazy () { return this.$eventBus.$data.Lazy }
  },
  methods: {
    isInViewport (elem) {
      var bounding = elem.getBoundingClientRect()
      return (
        bounding.top < document.documentElement.clientHeight) // &&
      // bounding.bottom >= (window.innerHeight || document.documentElement.clientHeight)
    },
    loadLazyComponent () {
      this.$eventBus.$data.Lazy = () => import('../components/Lazy')
      window.removeEventListener('scroll', this.loadLazyComponent)
    }
  },
  created () {
    this.$eventBus.IpoCreditIsMounted = true

    // SCROLL LISTENER
    window.addEventListener('scroll', this.loadLazyComponent)
  }

}
</script>

<style lang="stylus" scoped>

header
  position relative

.section
  padding-left 1rem
  padding-right 1rem

// <<< 768px
// @media (max-width: 768px)

// 769px >>>
// @media (min-width: 769px)

</style>



// WEBPACK FOOTER //
// src/components/IpoCredit.vue